import React, { useRef } from "react";
import { useGLTF, Outlines } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

export default function Model(props) {
  const { nodes, materials, animations } = useGLTF("/plots/09-Theater.glb");
  const outlineThickness = .008

  let built = props.built
  const model = useRef()

  useFrame((state, delta) => {
    if(!built && model.current.scale.y < 1)
    {
      AnimateIn()
    }
    else
    {
      IdleAnimation()
    }
  })

  function AnimateIn() {
    model.current.scale.y += (1 - model.current.scale.y) / 10
    model.current.scale.x += (1 - model.current.scale.x) / 10
    model.current.scale.z += (1 - model.current.scale.z) / 10
    if(model.current.scale.y > .997)
    {
      model.current.scale.x = 1
      model.current.scale.y = 1
      model.current.scale.z = 1
      // console.log(model.current.scale)
    }
  }

  function IdleAnimation()
  {
    // console.log('idleAnimating')
  }
  
  return (
    <group {...props} dispose={null} ref={model} scale={[.7,.2,.7]}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube410.geometry}
        material={materials["00-Base4"]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube411.geometry}
        material={materials["17-TheaterWalls"]}
        position={[-0.19, 0.489, -0.183]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube413.geometry}
        material={materials["17-TheaterWhite"]}
        position={[0.151, 0.481, 0.181]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube415.geometry}
        material={materials["12-TownhomeBuilding1"]}
        position={[-0.19, 0.913, -0.183]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube419.geometry}
        material={materials["12-TownhomeBasements"]}
        position={[0.151, 0.502, 0.183]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube420.geometry}
        material={materials["16-MovieTheater"]}
        position={[0.483, 0.358, -0.257]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <group position={[-0.851, 0.101, -0.847]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube456.geometry}
          material={materials["11-SidewalkConcrete"]}
        ><Outlines thickness={outlineThickness}/></mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube456_1.geometry}
          material={materials["00-Base3.001"]}
        ><Outlines thickness={outlineThickness}/></mesh>
      </group>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube560.geometry}
        material={materials["07-WindowMat"]}
        position={[-0.529, 0.247, 0.533]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube563.geometry}
        material={materials["16-TheaterBricks"]}
        position={[-0.13, 0.715, 0.315]}
        rotation={[0, Math.PI / 2, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder084.geometry}
        material={materials["12-TownhomeBasements"]}
        position={[0.582, 0.187, 0.836]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text001.geometry}
        material={materials["17-NeonSign"]}
        position={[0, 1.034, 0.122]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={0.165}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text002.geometry}
        material={materials["12-TownhomeBasements"]}
        position={[0.15, 0.463, 0.485]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={0.061}
      ><Outlines thickness={outlineThickness}/></mesh>
    </group>
  );
}

useGLTF.preload("/plots/09-Theater.glb");
